module.exports = __webpack_public_path__ + "img/chart_edit.29e14a56.svg";